import { Brand, Program } from '..';

const BookabachPrograms: Record<string, Program> = {
  'nz-bookabach': {
    id: 'nz-bookabach',
    name: 'Bookabach NZ',
    brand: Brand.BOOKABACH,
    posa: 'NZ',
    currency: 'NZD',
    locale: {
      baseName: 'en_NZ',
      langId: 5129,
    },
  },
};

export { BookabachPrograms };
